export default function About() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
              What Is Superbuy Spreadsheet
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-5">
              The Smart Way to Discover <br />
              <span className="italic text-primary-500">Organized Shopping</span> Resources
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              Superbuy Spreadsheet is an organized collection of shopping resources that helps users discover products, compare options, review information, and make smarter purchasing decisions. Instead of searching thousands of random listings, you get structured categories, guides, comparisons, and expert recommendations — all in one place.
            </p>

            <div className="grid grid-cols-3 gap-6">
              {[
                { num: '14+', label: 'Product Categories' },
                { num: '500+', label: 'Curated Finds' },
                { num: '10+', label: 'SEO Guides' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">
                    {stat.num}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-accent-100/50">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="grid grid-cols-3 gap-3 p-6 w-full max-w-sm">
                  {[...Array(9)].map((_, i) => (
                    <div
                      key={i}
                      className="aspect-square rounded-lg bg-background-50/80 backdrop-blur-sm flex items-center justify-center"
                    >
                      <div className={`w-3 h-3 rounded-full ${i % 3 === 0 ? 'bg-primary-400' : i % 3 === 1 ? 'bg-accent-400' : 'bg-secondary-400'}`}></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}